import { render, staticRenderFns } from "./UserInterview.vue?vue&type=template&id=a08fa156&"
import script from "./UserInterview.vue?vue&type=script&lang=js&"
export * from "./UserInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports